import * as React from 'react';
import { connect } from 'react-redux';
import NavBar from './NavBar';
import Container from './Container';
import SideBar from './Sidebar/SideBar';
const FloatingChatSupport = React.lazy(() => import('./Usuarios/FloatingChatSupport')); 

class Landing extends React.Component {
  render() {
    return (
      <div className="App" id="main-wrapper">
        <NavBar idSeller={this.props.idSeller} user={this.props.user} />
        <SideBar />
        <Container />
        <React.Suspense fallback={null}>
          <FloatingChatSupport />
        </React.Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idSeller: state.general?.idSeller,
  user: state.general,
});

export default connect(mapStateToProps)(Landing);
